<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M140.001-254.616V-300h679.998v45.384H140.001Zm0-202.692v-45.384h679.998v45.384H140.001Zm0-202.692v-45.384h679.998V-660H140.001Z"/></svg>
</template>
